import { createContext } from 'react';
import type { ArTableUIState } from '../state/createArTableState';

export type ArTableUIStateContextValue = ArTableUIState;

export const ArTableUIStateContext = createContext<ArTableUIStateContextValue | null>(
  null
);


